import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const Container = styled.div `
  .container-extended {
    display: flex;
    flex-direction: column;
    align-items: center;

    height: auto;
    min-height: 310px;
    margin-bottom: 15px;
    border-right: 1px solid ${Color.greySeparator};

    ${breakpoints.phone} {
      flex-direction: row;
      justify-content: center;
      width: 100%;
      align-items: flex-start;
      border-right: none;
      margin-top: 10px;
      height: auto;
      min-height: 210px;

      @media (max-width: 476px) {
        justify-content: space-around;
      }
    }

    .content-one {
      order: 2;
      display: flex;
      flex-direction: column;
      align-items: center;

      ${breakpoints.phone} {
        margin-top: 15px;
        width: 300px;
        margin-left: -20px;
      }
    }
    .content-two {
      order: 1;

      ${breakpoints.phone} {
        margin-top: -8px;
      }
      @media (max-width: 476px) {
        margin-left: -20px;
      }
    }

    .part-of {
      order: 3;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      color: ${Color.black000};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:${ColorDark.textLight};
        }
      }
      h2 {
        ${Font.sansBold}
        font-size: 21px;
        line-height: 24px;
        text-align: center;
        ${breakpoints.mobileFirst} {
          font-size: 19px;
        }
      }
      .w-description {
        ${Font.sansLight}
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        width: 85%;
      }
    }

    .icon {
      display: flex;
      min-height: 110px;
      align-items: center;
      figure {
        order: 1;
        width: 87px;
      }
    }

    .min-max {
      order: 2;
      display: flex;
      flex-direction: row;
      width: 170px;
      justify-content: space-between;

      @media (min-width: 976px) and (max-width: 1360px) {
        width: 140px;
    }

      .max-p,
      .min-p {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        ${Font.sansLight}

        p {
          font-size: 16px;
          line-height: 20px;
        }

        span {
          font-size: 36px;
          line-height: 24px;
        }
      }
    }
  }
`;